module.exports = __webpack_public_path__ + "img/liotron_100ah.f20650ba.png";